import { RouteLocationNormalized } from "vue-router";

// widgets
import { useSearchStudentContextStore } from "@/widgets/search-students/models/store/search-student-context";

/**
 * 학생 관리 페이지로 이동 시 학생 상태를 리셋하는 가드
 * @param to 이동할 라우트
 * @param from 현재 라우트
 */
export const resetStudentStateGuard = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
) => {
    const searchStudentContextStore = useSearchStudentContextStore();

    if (from.name !== "student-setting" && to.name === "student-setting") {
        searchStudentContextStore.resetState();
    }
};
